import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { User } from '../../models/user';
import { FeathersService } from './feathers.service';
import { ApiEndpoint } from '../../enums';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  me$;

  constructor(private feathers: FeathersService) {
    this.me$ = this.feathers.me$;
  }

  updateProfile(
    changes: Partial<Pick<User, 'name' | 'image' | 'attributes'>>
  ): Observable<User> {
    return defer(() =>
      this.feathers.patch(
        ApiEndpoint.Users,
        this.feathers.me$.value?._id!,
        changes
      )
    );
  }

  watchUser(id: string): Observable<User> {
    return this.feathers.watchItem(ApiEndpoint.Users, id);
  }

  deleteSelfAccount() {
    return this.feathers.delete(
      ApiEndpoint.Users,
      this.feathers.me$.value?._id!
    );
  }

  reactivateAccount(token: string) {
    return this.feathers.post(ApiEndpoint.AccountReactivation, { token });
  }
}
